import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Text, Table as SparkyTable } from '@eneco/sparky';
import { wrap } from '@sitecore/common';
import { TableRendering } from '@sitecore/types/manual/Table';

const Table: FC<TableRendering> = ({ fields }) => {
  return (
    <SparkyTable title={fields.title?.value}>
      {fields.headerRows?.length ? (
        <SparkyTable.Header>
          {fields.headerRows[0].columns.map((column, i) => (
            <Text key={i}>{wrap(column.content, <RichText html={column.content.value} />)} </Text>
          ))}
        </SparkyTable.Header>
      ) : null}

      {fields.rows?.length
        ? fields.rows.map((row, i) => (
            <SparkyTable.Row key={i}>
              {row.columns.map((column, i) => (
                <Text key={i}>{wrap(column.content, <RichText html={column.content.value} />)} </Text>
              ))}
            </SparkyTable.Row>
          ))
        : null}

      {fields.sections?.length
        ? fields.sections.map((section, i) => {
            if (!section.rows?.length) return null;

            return (
              <SparkyTable.Section isCollapsible={section.collapsible} title={section?.title?.value} key={i}>
                {section.rows?.length
                  ? section.rows.map((row, i) => (
                      <SparkyTable.Row key={i}>
                        {row.columns.map((column, i) => (
                          <Text key={i}>{wrap(column.content, <RichText html={column.content.value} />)} </Text>
                        ))}
                      </SparkyTable.Row>
                    ))
                  : null}

                {section.footerRows?.length ? (
                  <SparkyTable.Row isFooter>
                    {section.footerRows[0].columns.map((column, i) => (
                      <Text key={i}>{wrap(column.content, <RichText html={column.content.value} />)} </Text>
                    ))}
                  </SparkyTable.Row>
                ) : null}
              </SparkyTable.Section>
            );
          })
        : null}

      {fields.footerRows?.length ? (
        <SparkyTable.Row isFooter>
          {fields.footerRows[0].columns.map((column, i) => (
            <Text key={i}>{wrap(column.content, <RichText html={column.content.value} />)} </Text>
          ))}
        </SparkyTable.Row>
      ) : null}
    </SparkyTable>
  );
};

export { Table };
export default Table;
